
  // Don't change! This file is auto-generated
  const globalContent = {
  "_createdAt": "2021-02-08T15:53:47Z",
  "_id": "global-content-singleton",
  "_rev": "kxbbiCJYscCrSKaDAC7aUP",
  "_type": "global-content-singleton",
  "_updatedAt": "2023-08-30T08:21:45Z",
  "fields": {
    "footer": {
      "footerAddressCompanyName": "Viesus AG",
      "footerAddressCountry": "Switzerland",
      "footerAddressHeading": "Located:",
      "footerAddressPostalCity": "8157 | Dielsdorf | Canton of Zurich",
      "footerAddressStreet": "Niederhaslistrasse 14",
      "footerContactEmail": "info@viesus.com",
      "footerContactText": "Feel free to get in touch with one of our sales representatives for any questions you might have.",
      "footerTitle": "We’re here for any questions."
    },
    "getInTouch": {
      "_type": "object",
      "getInTouchBackground": {
        "_type": "image",
        "asset": {
          "_ref": "image-967ca5ce2868c7aa8b1a8daf4798ef05d643a187-1500x1500-jpg",
          "_type": "reference"
        }
      },
      "getInTouchDescriptionOnImage": [
        {
          "_key": "a215a78a6eb7",
          "_type": "block",
          "children": [
            {
              "_key": "be6cfe01a1d7",
              "_type": "span",
              "marks": [],
              "text": "Viesus™ is the leading fully automatic image enhancement software, used on "
            },
            {
              "_key": "8f8638b28ade",
              "_type": "span",
              "marks": [
                "strong"
              ],
              "text": "tens of millions of images"
            },
            {
              "_key": "5b9d523006c3",
              "_type": "span",
              "marks": [],
              "text": " each day."
            }
          ],
          "markDefs": [],
          "style": "normal"
        }
      ],
      "getInTouchLogos": [
        {
          "_key": "3a26a258c0e2",
          "getInTouchLogo": {
            "_type": "image",
            "asset": {
              "_ref": "image-bd63f39171c9015f3906c30ea1a10f753fb9350b-400x77-png",
              "_type": "reference"
            }
          }
        },
        {
          "_key": "2739e8d96608",
          "getInTouchLogo": {
            "_type": "image",
            "asset": {
              "_ref": "image-44ed381d209a0a36ef6f6e96aa3244366b01f312-265x34-png",
              "_type": "reference"
            }
          }
        },
        {
          "_key": "78c4a1332f6a",
          "getInTouchLogo": {
            "_type": "image",
            "asset": {
              "_ref": "image-bec2965ac775cd9f3d27b266dc06f07751b40bd7-435x67-png",
              "_type": "reference"
            }
          }
        },
        {
          "_key": "43bcc60b96d8",
          "getInTouchLogo": {
            "_type": "image",
            "asset": {
              "_ref": "image-bfe7f025e0d68b8419b0179b464ec64dd6e3db44-306x104-png",
              "_type": "reference"
            }
          }
        }
      ],
      "getInTouchTitle": "Let’s get in touch."
    }
  },
  "getInTouchBackground": "https://cdn.sanity.io/images/a1ay4e5s/production/967ca5ce2868c7aa8b1a8daf4798ef05d643a187-1500x1500.jpg",
  "logos": [
    {
      "logo": {
        "metadata": {
          "dimensions": {
            "_type": "sanity.imageDimensions",
            "aspectRatio": 5.194805194805195,
            "height": 77,
            "width": 400
          }
        },
        "url": "https://cdn.sanity.io/images/a1ay4e5s/production/bd63f39171c9015f3906c30ea1a10f753fb9350b-400x77.png"
      }
    },
    {
      "logo": {
        "metadata": {
          "dimensions": {
            "_type": "sanity.imageDimensions",
            "aspectRatio": 7.794117647058823,
            "height": 34,
            "width": 265
          }
        },
        "url": "https://cdn.sanity.io/images/a1ay4e5s/production/44ed381d209a0a36ef6f6e96aa3244366b01f312-265x34.png"
      }
    },
    {
      "logo": {
        "metadata": {
          "dimensions": {
            "_type": "sanity.imageDimensions",
            "aspectRatio": 6.492537313432836,
            "height": 67,
            "width": 435
          }
        },
        "url": "https://cdn.sanity.io/images/a1ay4e5s/production/bec2965ac775cd9f3d27b266dc06f07751b40bd7-435x67.png"
      }
    },
    {
      "logo": {
        "metadata": {
          "dimensions": {
            "_type": "sanity.imageDimensions",
            "aspectRatio": 2.9423076923076925,
            "height": 104,
            "width": 306
          }
        },
        "url": "https://cdn.sanity.io/images/a1ay4e5s/production/bfe7f025e0d68b8419b0179b464ec64dd6e3db44-306x104.png"
      }
    }
  ]
};
  export default globalContent
  export type GlobalContent = typeof globalContent
